import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/global.scss"
import Vant from 'vant';
import 'vant/lib/index.css';
import VConsole from 'vconsole';

if(process.env.NODE_ENV !== 'production'){
  new VConsole()
}

Vue.use(Vant);
Vue.config.productionTip = false

Vue.use(ElementUI);

let clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "默往";
  if(to.path === "/" && clientWidth < 500){
    next("/download");
  }else{
    next();
  }
})

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
